import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function UsersRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Supliers />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Supliers />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Supliers />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.Suplier match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.Suplier />
            </Route>
        </Switch>
    );
}

